import { camelizeKeys } from "humps";
import store from "@/store/index";
import axios from "axios";

import BaseService from "./BaseService";

export default {
  whiteLabel() {
    return axios
      .get(`${BaseService.apiUrl()}/v1/white-label`)
      .then(response => {
        store.dispatch(
          "setPractice",
          camelizeKeys(response.data.data.attributes)
        );
      });
  },

  insertStyles(href) {
    const head = document.getElementsByTagName("head")[0];
    const link = document.createElement("link");
    link.setAttribute("rel", "stylesheet");
    link.setAttribute("href", href);
    head.appendChild(link);
  }
};
